import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="mt-16 mb-32">
      {/* Social Links */}
      <div className="flex flex-col items-center gap-6">
        {/* Social Icons */}
        <div className="flex items-center justify-center gap-8">
          <a 
            href="https://www.tiktok.com/@doihaveenoughbitcoin"
            target="_blank"
            rel="noopener noreferrer"
            className="group"
          >
            <img 
              src="/tiktok.svg" 
              alt="TikTok" 
              className="w-6 h-6 transition-all duration-300 group-hover:scale-110 opacity-60 group-hover:opacity-100 [filter:grayscale(100%)] group-hover:[filter:none] group-hover:[filter:brightness(0)_saturate(100%)_invert(56%)_sepia(83%)_saturate(5333%)_hue-rotate(1deg)_brightness(101%)_contrast(102%)]" 
            />
          </a>
          <a 
            href="https://x.com/EnoughBitcoin"
            target="_blank"
            rel="noopener noreferrer"
            className="group"
          >
            <img 
              src="/x.svg" 
              alt="X (Twitter)" 
              className="w-6 h-6 transition-all duration-300 group-hover:scale-110 opacity-60 group-hover:opacity-100 [filter:grayscale(100%)] group-hover:[filter:none] group-hover:[filter:brightness(0)_saturate(100%)_invert(56%)_sepia(83%)_saturate(5333%)_hue-rotate(1deg)_brightness(101%)_contrast(102%)]" 
            />
          </a>
          <a 
            href="https://www.instagram.com/doihaveenoughbitcoin/"
            target="_blank"
            rel="noopener noreferrer"
            className="group"
          >
            <img 
              src="/instagram.svg" 
              alt="Instagram" 
              className="w-6 h-6 transition-all duration-300 group-hover:scale-110 opacity-60 group-hover:opacity-100 [filter:grayscale(100%)] group-hover:[filter:none] group-hover:[filter:brightness(0)_saturate(100%)_invert(56%)_sepia(83%)_saturate(5333%)_hue-rotate(1deg)_brightness(101%)_contrast(102%)]" 
            />
          </a>
        </div>

        {/* Creator Attribution */}
        <a 
          href="https://x.com/zaidazmi" 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-all duration-300 group"
        >
          <span className="text-sm">Created by</span>
          <img 
            src="/x.svg" 
            alt="X (Twitter) Logo" 
            className="w-4 h-4 transition-all duration-300 group-hover:scale-110 opacity-60 group-hover:opacity-100 [filter:grayscale(100%)] group-hover:[filter:none]" 
          />
          <span className="text-sm font-medium">zaidazmi</span>
        </a>
      </div>
    </footer>
  );
};

export default Footer; 